export default __webpack_public_path__ + "static/media/single-community.f618bbfc.png";